import {
  FETCH_CLIENTS_SUCCESS,
  FETCH_RECIPIENTS_SUCCESS,
  FETCH_USER_SUCCESS,
  FETCH_USERS_SUCCESS
} from '../constants'

const initialState = {
  user: {},
  users: [],
  clients: [],
  recipients: []
}

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.clients
      }
    case FETCH_RECIPIENTS_SUCCESS:
      return {
        ...state,
        recipients: action.recipients
      }
    case FETCH_USER_SUCCESS:
      return {
        ...state,
        user: action.user
      }
    case FETCH_USERS_SUCCESS:
      return {
        ...state,
        users: action.users
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/admin.js